// 관리자 신규 주문 알림 토글.
// 주문 관리 화면 헤더에 둔다. 사장/직원이 이 버튼으로 신규 주문 푸시를 켠다.
//  - 미지원/미설정 환경은 비활성 안내. iOS Safari 데스크톱은 제한적일 수 있다 (운영 PC 는 보통 크롬/엣지).

import { useEffect, useState } from "react";
import {
  getNotificationPermission,
  isCurrentlySubscribed,
  isPushSupported,
  subscribeAdminPush,
  unsubscribeAdminPush,
} from "./pushClient.ts";

// 관리자 신규주문 푸시 알림 구독/해제 토글.
export default function AdminPushToggle() {
  const [supported] = useState(isPushSupported);
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!supported) {
      return;
    }
    void isCurrentlySubscribed().then(setSubscribed);
  }, [supported]);

  if (!supported) {
    return <span className="text-xs text-ink-600">알림 미지원 브라우저</span>;
  }

  async function onEnable() {
    setBusy(true);
    setMessage(null);
    const result = await subscribeAdminPush();
    setBusy(false);
    if (result.ok) {
      setSubscribed(true);
      return;
    }
    const reasonMsg: Record<string, string> = {
      denied: "브라우저에서 알림 권한을 허용해 주세요.",
      unsupported: "이 브라우저는 알림을 지원하지 않습니다.",
      "not-configured": "알림 기능이 아직 설정되지 않았습니다.",
      error: "알림을 켜지 못했습니다.",
    };
    setMessage(reasonMsg[result.reason] ?? "알림을 켜지 못했습니다.");
  }

  async function onDisable() {
    setBusy(true);
    setMessage(null);
    try {
      await unsubscribeAdminPush();
      setSubscribed(false);
    } catch {
      setMessage("알림을 끄지 못했습니다.");
    } finally {
      setBusy(false);
    }
  }

  const permission = getNotificationPermission();

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={subscribed ? onDisable : onEnable}
        disabled={busy || permission === "denied"}
        className={`h-8 rounded-md px-3 text-xs font-semibold disabled:opacity-50 ${
          subscribed
            ? "border border-ink-300 text-ink-700 hover:bg-ink-100"
            : "bg-brand-600 text-white hover:bg-brand-700"
        }`}
      >
        {busy ? "처리 중..." : subscribed ? "신규주문 알림 끄기" : "신규주문 알림 켜기"}
      </button>
      {message ? <span className="text-[11px] text-warning-700">{message}</span> : null}
    </div>
  );
}
